/* eslint-disable @typescript-eslint/default-param-last */
import { IIManageInterviewersModalAction } from '../../types/Interviews/manageInterviewersModal.types';
import {
  HIDE_MANAGE_INTERVIEWERS_MODAL,
  SHOW_MANAGE_INTERVIEWERS_MODAL,
} from '../../constants/ActionTypes';
import initialState from '../../store/initialState';

const manageInterviewerModalReducer = (
  state = initialState.manageInterviewersModal,
  action: IIManageInterviewersModalAction
) => {
  switch (action.type) {
    case SHOW_MANAGE_INTERVIEWERS_MODAL:
      return { ...state, show: action.payload.show };
    case HIDE_MANAGE_INTERVIEWERS_MODAL:
      return {
        ...state,
        show: action.payload.show,
      };
    default:
      return state;
  }
};

export default manageInterviewerModalReducer;
